import { render, staticRenderFns } from "./StaffTable.vue?vue&type=template&id=05b5b7fe&"
import script from "./StaffTable.vue?vue&type=script&lang=js&"
export * from "./StaffTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports